export const calculateViewportTopReductionForFit = (tipRect?: DOMRect) => {
  const fitsTop = Math.min(0, tipRect?.top || 0) !== 0;
  if (!fitsTop) return 0;
  return tipRect?.top;
};

const ITEM_HIGHT: number = 29;

function calculateTopOverflow(height: number, absoluteY?: number) {
  //we will try to predict y by summing number of ui pixels
  if (!absoluteY) return 0;
  const yBottom = absoluteY - scrollY - height;
  return yBottom;
}

/**
 * Calculates the total height of a list of items with predefined padding.
 *
 * @param numItems The number of items in the list.
 * @returns The total height of the list in pixels.
 */
const calculateListHeight = (numItems: number) => {
  const totalHeight = numItems * ITEM_HIGHT;
  return totalHeight;
};

/**
 * Calculates the number of items that can fit within a given height,
 * using predefined item height and total padding.
 *
 * @param itemHeight The total available height in pixels.
 * @returns The number of items that can fit, rounded down to the nearest whole number.
 */
const calculateMaxHeightItems = (itemHeight: number) => {
  // Calculate the number of items
  const numItems = Math.floor(itemHeight / ITEM_HIGHT);
  return numItems;
};

export const calculateAdaptiveItems = <D = any[]>(
  items: D[],
  absoluteY?: number,
  getImportant?: (item: D[]) => D | undefined
) => {
  const itemsLength = items.length;
  const height = calculateListHeight(itemsLength);
  const fitsPx = calculateTopOverflow(height, absoluteY);
  if (fitsPx >= 0)
    return { fits: true, fitCount: itemsLength, excludeCount: 0, items };
  const fitCount = calculateMaxHeightItems(height - Math.abs(fitsPx));
  const excludeCount = itemsLength - fitCount;
  const newItems = items.slice(0, fitCount);
  // get important item should only return item that is not included in the newItems
  // array but is in the original items array and is important to the list to be shown
  const importantItem = getImportant?.(newItems);

  if (importantItem) {
    //insert important item at the end
    newItems[fitCount - 1] = importantItem;
  }

  return { fitCount, fits: false, excludeCount, items: newItems };
};

export const getStackedYData = (xDate, yValue, stackedSeries) => {
  if (!xDate) return null;
  //find the layer that contains the xDate and yValue
  for (const layer of stackedSeries) {
    const segment = layer.find(d => d.data.date?.getTime() === xDate.getTime());

    if (segment && yValue >= segment[0] && yValue < segment[1]) {
      return {
        xDate,
        key: layer.key,
        y0: segment[0],
        y1: segment[1],
        segmentValue: segment[1] - segment[0],
        originalDataPoint: segment.data
      };
    }
  }

  return null;
};
